export default __webpack_public_path__ + "static/media/bg-img.8a38c12a.png";